import React, { useState, useEffect } from 'react';
import './css/userManagement.css';
import UserTable from './components/UserTable';
import UserCreate from './components/UserCreate';
import { useApp } from '../../context/AppContext';
import PropTypes from 'prop-types';

function UserManagement({ initialTab = 'users' }) {
  const { permissions } = useApp();
  const [activeTab, setActiveTab] = useState(initialTab);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  const getPageHeader = () => {
    switch (activeTab) {
      case 'users':
      default:
        return {
          title: 'User Management',
          description: 'View and manage all user accounts',
        };
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'users':
      default:
        return <UserTable onCreateUser={() => permissions.includes('CREATE_USERS') && setShowCreateModal(true)} />;
    }
  };

  const headerData = getPageHeader();

  return (
    <div className="eduss-user-management">
      <div className="eduss-page-header">
        <div>
          <h2>{headerData.title}</h2>
          <p>{headerData.description}</p>
        </div>
        <div className="eduss-dashboard-banner-date">
          {new Date().toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </div>
      </div>

      <div className="eduss-user-management-content">{renderContent()}</div>

      {/* Create User Modal */}
      {showCreateModal && permissions.includes('CREATE_USERS') && (
        <div
          className="eduss-global-modal-overlay"
          onClick={() => setShowCreateModal(false)}
        >
          <div
            className="eduss-global-modal"
            onClick={e => e.stopPropagation()}
          >
            <div className="eduss-global-modal-header">
              <h3>Create New User Account</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <UserCreate onClose={() => setShowCreateModal(false)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

UserManagement.propTypes = {
  initialTab: PropTypes.string,
};

export default UserManagement;
